import { topicsItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            全网最热话题标签，看看大家都在讨论什么
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topicsItems.map((item, i) => (
            <a
              key={i}
              href="#updates"
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-full hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}